
export enum JobCompletedEnum {
    YES = 'YES',
    NO = 'NO',
}